module.exports = __webpack_public_path__ + "img/case5.aae70e04.jpg";